import PaginationCountFeedbackComponent from './PaginationCountFeedbackComponent';
export * from './PaginationCountFeedbackComponent';
export default PaginationCountFeedbackComponent;
